// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"356":"efe5c0a4","694":"f1942e09","788":"8d0b983f","892":"ef20dfb4"}[chunkId] + ".chunk.css";
};